"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ThemePicker = _interopRequireDefault(require("@/components/ThemePicker"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    ThemePicker: _ThemePicker.default
  },
  data: function data() {
    return {};
  },
  computed: {
    fixedHeader: {
      get: function get() {
        return this.$store.state.setting.fixHeader;
      },
      set: function set(val) {
        this.$store.commit('setting/fixHeader', val);
      }
    },
    tagsView: {
      get: function get() {
        return this.$store.state.setting.multipage;
      },
      set: function set(val) {
        this.$store.commit('setting/setMultipage', val);
      }
    },
    sidebarLogo: {
      get: function get() {
        return this.$store.state.setting.sidebarLogo;
      },
      set: function set(val) {
        this.$store.commit('setting/setSidebarLogo', val);
      }
    },
    uniqueOpened: {
      get: function get() {
        return this.$store.state.setting.uniqueOpened;
      },
      set: function set(val) {
        this.$store.commit('setting/setUniqueOpened', val);
      }
    }
  },
  methods: {
    themeChange: function themeChange(val) {
      this.$store.commit('setting/setTheme', val);
    }
  }
};
exports.default = _default;